import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import ProductHeader from "../components/productheader"
import ProductSection from "../components/productsection"
import ObviousCheckout1 from "../images/obvious_checkout_1.jpg"
import ObviousCheckout2 from "../images/obvious_checkout_2.jpg"

const ObviousCheckout = () => (
  <Layout>
    <SEO title="Obvoius Checkout" />
    <div className="relative max-w-screen-lg mx-auto">
      <ProductHeader title="Obvious Checkout" subtitle="Front-end | Design" />
      <ProductSection image={ObviousCheckout1} />
      <ProductSection image={ObviousCheckout2} />
    </div>
  </Layout>
)

export default ObviousCheckout
